import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class JustificativaForm extends Component {
  state = {
    registro: {
      justificativa: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {

  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.justificativa) || (this.state.registro.justificativa === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if (this.state.registro.justificativa.length < 5) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição com no mínimo 5 caracteres' });
      return;
    }

    const reg = {
      reg: this.props.registro,
      justificativa: this.state.registro.justificativa
    }

    this.setState({
      registro: {
        justificativa: '',
      }
    });

    this.props.onJustifClick(reg);
  };

  render() {
    const { onCancelarJustifClick, carregando, visivel, tituloTela, descrCampo } = this.props;
    const { justificativa } = this.state.registro;

    // console.log('JustificativaForm.this.state: ', this.props);
    // console.log('JustificativaForm.this.state: ', this.state);

    return (
      <Modal
        title={tituloTela ? tituloTela : "Justificativa"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarJustifClick}
        footer={null}
        width={"30%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>{descrCampo ? descrCampo : "Justificativa"}</span>
              <InputForm
                id="justificativa"
                ref="justificativa"
                type="textarea"
                rows={tituloTela === "Observação do Pedido" ? 5 : 1}
                maxLength={tituloTela === "Observação do Pedido" ? 450 : 50}
                onChange={this.onChange}
                value={justificativa}
                validator={value => Boolean(value)}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarJustifClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JustificativaForm.js